import * as actions from "../action.constants";

const initialState = {
  dashboards: [],
  dashboardCellsData: {},
  widgets: [],
};

const storeDashboards = (state, action) => {
  return {
    ...state,
    dashboards: action.payload,
  };
};

const storeDashboardCellsData = (state, action) => {
  return {
    ...state,
    dashboardCellsData: action.payload,
  };
};

const storeWidgetsData = (state, action) => {
  return {...state, widgets: action.payload.results};
};

const handlers = {
  [actions.STORE_DASHBOARDS]: storeDashboards,
  [actions.STORE_DASHBOARD_CELLS_DATA]: storeDashboardCellsData,
  [actions.STORE_WIDGETS]: storeWidgetsData,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
